import React from "react";
import PropTypes from "prop-types";
import { pick } from "lodash";

import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import {
  AIRCRAFT_REFERENCE_NUMBER,
  AIRCRAFT_TAIL_NUMBER,
  ASA,
  CAAC,
  CONDITION,
  CONSIGNMENT_TYPE,
  DO_NOT_EXCHANGE,
  EASA,
  EXCHANGE_SRP,
  EXPIRATION,
  FAA,
  FREIGHT_COMPLETE,
  LAST_SRP_REASON_CHANGED,
  LISTING_OVERRIDE,
  LOCATION,
  MODIFIED,
  OTHER,
  OTHER_TAG_TYPE,
  PART_ID,
  RESERVE_FOR_REPAIR,
  SERIAL_NUMBER,
  SRP_CONDITION,
  STORE_LOCATION_ID,
  STORE_OWNER_ID,
  SUGGESTED_RETAIL,
  TAG_DATE,
  TAGGED_BY,
  TCCA,
  TOTAL_CYCLES_REMAINING,
  TOTAL_HOURS_REMAINING,
  TRACE_TYPE,
  TRACED_TO,
  UK_CAA,
  UNSELLABLE_PER_USER,
  WARRANTY_OVERRIDE
} from "MODULES/inventories/constants";
import { BUYER_CREDIT_PCT, ID, QUANTITY } from "APP_ROOT/constants";
import {
  CONSIGNMENT_REFERENCE,
  CONSIGNOR_PERCENTAGE
} from "MODULES/Receiving/constants";
import {
  IMPERFECT_TRACE,
  DER,
  IMPERFECT_TRACE_REASON
} from "MODULES/companies/constants";
import { DOM, PMA, TOTAL_CYCLES, TOTAL_HOURS } from "MODULES/parts/constants";
import { CO_BUYER_ID, THIRD_BUYER_ID } from "MODULES/users/constants";
import { INCIDENT } from "MODULES/PurchaseOrders/constants";
import {
  totalCyclesRemaining,
  totalHoursRemaining
} from "MODULES/inventories/helpers";
import Form from "./Form";

export default function EditInventory({
  open,
  close,
  inventory,
  lockInventory
}) {
  const jsInventory = inventory.toJS();
  const initialValues = pick(jsInventory, [
    "revision_number",
    AIRCRAFT_REFERENCE_NUMBER,
    AIRCRAFT_TAIL_NUMBER,
    ASA,
    BUYER_CREDIT_PCT,
    CAAC,
    CO_BUYER_ID,
    CONDITION,
    CONSIGNMENT_TYPE,
    CONSIGNOR_PERCENTAGE,
    CONSIGNMENT_REFERENCE,
    "correct_serial_number",
    DER,
    DOM,
    DO_NOT_EXCHANGE,
    "do_not_sell_reason",
    EASA,
    EXCHANGE_SRP,
    EXPIRATION,
    FAA,
    FREIGHT_COMPLETE,
    ID,
    IMPERFECT_TRACE,
    IMPERFECT_TRACE_REASON,
    INCIDENT,
    LAST_SRP_REASON_CHANGED,
    LISTING_OVERRIDE,
    LOCATION,
    OTHER_TAG_TYPE,
    PART_ID,
    PMA,
    QUANTITY,
    RESERVE_FOR_REPAIR,
    UNSELLABLE_PER_USER,
    SERIAL_NUMBER,
    "serial_number_correction_required",
    SRP_CONDITION,
    STORE_LOCATION_ID,
    STORE_OWNER_ID,
    SUGGESTED_RETAIL,
    TAG_DATE,
    TAGGED_BY,
    TCCA,
    THIRD_BUYER_ID,
    TOTAL_CYCLES,
    TOTAL_HOURS,
    TRACE_TYPE,
    TRACED_TO,
    UK_CAA,
    WARRANTY_OVERRIDE,
    "ware_house_id",
    MODIFIED
  ]);

  initialValues[OTHER] =
    initialValues[OTHER_TAG_TYPE] && initialValues[OTHER_TAG_TYPE].length > 0;

  initialValues[TOTAL_HOURS_REMAINING] = totalHoursRemaining(
    jsInventory.part,
    Number(jsInventory.total_hours)
  );

  initialValues[TOTAL_CYCLES_REMAINING] = totalCyclesRemaining(
    jsInventory.part,
    Number(jsInventory.total_cycles)
  );

  return (
    <Modal open={open} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Inventory Details</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        inventory={inventory}
        lockInventory={lockInventory}
        enableReinitialize
      />
    </Modal>
  );
}

EditInventory.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  inventory: PropTypes.shape({}),
  lockInventory: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/EditInventory/EditInventory.jsx